import { ACTION, GenericObject, actionKeyGenerate } from "src/util/utils";

export const MODULE_KEY = "INVENTORY_FINAL_UPDATE";
export const INVENTORY_FINAL_UPDATE_IMPORT_FILE = "INVENTORY_FINAL_UPDATE_IMPORT_FILE";
export const INVENTORY_FINAL_UPDATE_IMPORT_FILE_SUCCESS = "INVENTORY_FINAL_UPDATE_IMPORT_FILE_SUCCESS";
export const INVENTORY_FINAL_UPDATE_IMPORT_FILE_FAILED = "INVENTORY_FINAL_UPDATE_IMPORT_FILE_FAILED";

export const InventoryFinalUpdate_CLEAN_IMPORT_LAYOUT = "InventoryFinalUpdate_CLEAN_IMPORT_LAYOUT";
export const INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT = "INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT";
export const INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT_SUCCESS = "INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT_SUCCESS";
export const INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT_FAILED = "INVENTORY_FINAL_UPDATE_VALIDATED_IMPORT_FAILED";
export const INVENTORY_FINAL_UPDATE_CLEAN_IMPORT_LAYOUT = "INVENTORY_FINAL_UPDATE_CLEAN_IMPORT_LAYOUT";

export const KEYS: GenericObject = actionKeyGenerate(MODULE_KEY);

export const INVENTORY_FINAL_UPDATE_FETCH = KEYS[MODULE_KEY + ACTION.FETCH];

export const fetchInventoryFinalUpdateSummary = (payload: any) => ({
  type: INVENTORY_FINAL_UPDATE_FETCH,
  payload,
});

export const fetchInventoryFinalUpdateSummarySuccess = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.SUCCESS],
  payload,
});

export const fetchInventoryFinalUpdateSummaryFailed = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.FAILED],
  payload,
});

export const importFile = (payload: any) => ({
  type: INVENTORY_FINAL_UPDATE_IMPORT_FILE,
  payload,
});

export const importFileSuccess = (payload: any) => ({
  type: INVENTORY_FINAL_UPDATE_IMPORT_FILE_SUCCESS,
  payload,
});

export const importFileFailed = (payload: any) => ({
  type: INVENTORY_FINAL_UPDATE_IMPORT_FILE_FAILED,
  payload,
});

export const cleanImportLayout = () => ({
  type: INVENTORY_FINAL_UPDATE_CLEAN_IMPORT_LAYOUT,
});

